var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxCartShopping = function Svg18PxCartShopping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m1.75 1.75 1.351.338a1 1 0 0 1 .747.825l1.153 7.838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.25 13.25H4.5a1.25 1.25 0 0 1 0-2.5h8.529a1 1 0 0 0 .949-.684l1.333-4a1 1 0 0 0-.949-1.316H4.118"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M3.75 17a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M14.25 17a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
  })));
};
export default Svg18PxCartShopping;